var map = {
	"./dark_SocialsInOne_fav.png": 609,
	"./dark_SocialsInOne_logo.png": 610,
	"./dark_bg-login.svg": 611,
	"./dark_dashboard_bg.jpg": 612,
	"./dark_dataak_fav.png": 613,
	"./dark_dataak_headlogo.svg": 614,
	"./dark_dataak_logo.svg": 615,
	"./dark_digitalMarketing_bg.jpg": 616,
	"./dark_irancell_labz_bg_login.svg": 617,
	"./dark_irancell_labz_favicon.png": 618,
	"./dark_irancell_labz_header_logo.svg": 619,
	"./dark_irancell_labz_logo.svg": 620,
	"./dark_kafir_fav.png": 621,
	"./dark_kafir_headlogo.png": 622,
	"./dark_manshour_fav.png": 623,
	"./dark_manshour_logo.png": 624,
	"./dark_matin_fav.png": 625,
	"./dark_matin_logo.png": 626,
	"./dark_mokhtar_fav.png": 627,
	"./dark_mokhtar_logo.png": 628,
	"./dark_pr_bg.jpg": 629,
	"./light_SocialsInOne_fav.png": 630,
	"./light_SocialsInOne_logo.png": 631,
	"./light_bg-login.svg": 632,
	"./light_dashboard_bg.jpg": 633,
	"./light_dataak_fav.png": 634,
	"./light_dataak_headlogo.svg": 635,
	"./light_dataak_logo.svg": 636,
	"./light_digitalMarketing_bg.jpg": 637,
	"./light_irancell_labz_bg_login.svg": 638,
	"./light_irancell_labz_favicon.png": 639,
	"./light_irancell_labz_header_logo.svg": 640,
	"./light_irancell_labz_logo.svg": 641,
	"./light_kafir_fav.png": 642,
	"./light_kafir_headlogo.png": 643,
	"./light_manshour_fav.png": 644,
	"./light_manshour_logo.png": 645,
	"./light_matin_fav.png": 646,
	"./light_matin_logo.png": 647,
	"./light_mokhtar_fav.png": 648,
	"./light_mokhtar_logo.png": 649,
	"./light_pr_bg.jpg": 650
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1098;